import * as S from './styles'

export const Content12 = () => {
    return (
        <S.Container>
            <S.TextBlock1>
                Все серверы TeleGuard расположены в Швейцарии, в ГЕО-независимых центрах обработки данных.
                В зависимости от требований заказчика TeleGuard может быть интегрирован в собственную ИТ-инфраструктуру компании.
            </S.TextBlock1>
            <S.TextBlock2>
                TeleGuard предназначен для обеспечения максимальной безопасности внутренних коммуникаций.
                Текстовые и голосовые сообщения, а также медиаданные внутри сообщества TeleGuard полностью зашифрованы.
            </S.TextBlock2>
        </S.Container>
    )
}